import axios from 'axios'

// Both lightweight checks run in parallel; allow a slow connection without
// leaving the initial screen waiting indefinitely.
export const API_HEALTHCHECK_TIMEOUT_MS = 10_000

export const validateApiCredentials = async (
    signal?: AbortSignal
): Promise<boolean> => {
    if (signal?.aborted) return false

    const controller = new AbortController()
    const cancel = () => controller.abort()
    const interrupted = new Promise<boolean>((resolve) => {
        controller.signal.addEventListener('abort', () => resolve(false), {
            once: true,
        })
    })
    signal?.addEventListener('abort', cancel, { once: true })
    const timeout = setTimeout(cancel, API_HEALTHCHECK_TIMEOUT_MS)

    try {
        const checks = Promise.all([
            axios.get(
                `${process.env.REACT_APP_API_URL}/api/health-check-read-token`,
                {
                    signal: controller.signal,
                    timeout: API_HEALTHCHECK_TIMEOUT_MS,
                    headers: {
                        Authorization: `Bearer ${process.env.REACT_APP_API_READ_TOKEN}`,
                    },
                }
            ),
            axios.get(
                `${process.env.REACT_APP_API_URL}/api/health-check-contact-form-token`,
                {
                    signal: controller.signal,
                    timeout: API_HEALTHCHECK_TIMEOUT_MS,
                    headers: {
                        Authorization: `Bearer ${process.env.REACT_APP_API_CONTACT_FORM_TOKEN}`,
                    },
                }
            ),
        ]).then(
            ([readTokenHealth, contactFormTokenHealth]) =>
                readTokenHealth.status === 200 &&
                contactFormTokenHealth.status === 200
        )

        // This deadline also settles the result if an adapter ignores abort.
        return await Promise.race([checks, interrupted])
    } catch {
        return false
    } finally {
        clearTimeout(timeout)
        signal?.removeEventListener('abort', cancel)
        cancel()
    }
}
